const { utils } = require("../../utils");

//{"isPaid":false,"isDelivered":false,"_id":"60fbeab809141538185b4de7","orderItems":[{"_id":"60fbeab809141538185b4de8","name":"Midi sundress with shirring detail","qty":1,"image":"/images/dress1.jpg","price":29.9,"productID":"60faef22c93b8c42d9b43533"}],"shippingAddress":{"fullName":"o x","address":"my address","email":"a@a.com"},"totalPrice":29.9,"user":"60f896f2a7fe9f22d4fcb412","createdAt":"2021-07-24T10:26:04.109Z","updatedAt":"2021-07-24T10:26:04.109Z","__v":0}


const reducer_order = (state = { loading:false}, action) => {
    switch (action.type) {
        case utils.constants.ORDER_CREATE_REQUEST: {
            return {
                // order: action.payload,
                loading: true
            }
        }
        case utils.constants.ORDER_CREATE_SUCCESS: {
            return {
                order: {...action.payload},
                loading: false
            }
        }        
        case utils.constants.ORDER_CLEAR: {
            return {
                order: null
            }
        }
        case utils.constants.ORDER_ACTION_FAIL: {
            return {
                error: action.payload,
                loading: false
            }
        }
        case utils.constants.ORDER_DELETE_REQUEST: {
            return {
                loading: true
            }
        }
        case utils.constants.ORDER_DELETE_SUCCESS: {
            return {
                deletedOrder: action.payload,
                loading: false,
            }
        }
        case utils.constants.ORDER_LIST_REQUEST: {
            return {
                loading: true,
            }
        }
        case utils.constants.ORDER_LIST_SUCCESS: {
            return {
                orders: action.payload,
                loading: false
            }
        }

        default:
            return { ...state };
    }
}

export default reducer_order;